export const conditions = [
  {
    title: 'Fair',
    percentage: '20%',
    descriptions: [
      'Requires some mechanical repairs',
      'The paint and bodywork may require refinishing and body repair; the body has severe dents, chips and/or scratches. May have some rust and corrosion damage',
      'The engine compartment has leaks and may require repairs',
      'The windshield has cracks',
      'Interior has substantial wear and may have tears',
      'Wheels may be warped or bent, have major scratches, scrapes, or pitting and require replacement',
      'The tires may not match or are worn and need replacing',
      'Needs servicing, but is still in reasonable running condition',
      'Has a clean title',
      'A few service records are available',
    ],
  },
  {
    title: 'Good',
    percentage: '50%',
    descriptions: [
      'Has repairable cosmetic defects and mechanical problems',
      'May need some servicing',
      'The paint and bodywork may require touch-ups and minor bodywork',
      'May have prior paint and bodywork completed',
      'The engine compartment may have leaks',
      'Has only repairable rust and corrosion, if any',
      'The body may have scratches or dings',
      'The windshield and interior have normal wear',
      'Wheels may have minor repairable scratches or scrapes',
      'All tires match and have at least 50% of tread remaining',
      'Though it may need some reconditioning',
      'Has a clean title history',
      'Will pass a safety and smog inspection',
      'Some service records are available',
    ],
  },
  {
    title: 'Very Good',
    percentage: '28%',
    descriptions: [
      'Has minor cosmetic defects and is in good mechanical condition',
      'Has had minor paint touch-ups and/or bodywork',
      'Requires some reconditioning',
      'The engine compartment is clean and free of leaks, rust or corrosion',
      'The body, windshield, and interior have minimal signs of wear or visible defects',
      'Wheels have minor flaws',
      'All tires match and have 75% or more of tread remaining',
      'Has a clean title history',
      'Will pass a safety and smog inspection',
      'Most service records are available',
    ],
  },
  {
    title: 'Excellent',
    percentage: '2%',
    descriptions: [
      'Looks new and is in excellent mechanical condition',
      'The engine compartment is clean and free of leaks, rust or corrosion',
      'The body, windshield, and interior are free of wear or visible defects',
      'Wheels are flawless',
      'All tires match and are like new',
      'Has a clean title history and will pass a safety and smog inspection',
      'Has complete and verifiable service records',
    ],
  },
];

export const TAX_SAVINGS = 'Potential Sales Tax Savings*';
export const THIRTY_DAY_DEPRECIATION = '30-Day Depreciation (Predicted)**';
export const TAX_SAVINGS_DISCLAIMER =
  '*Not available in all states. Check with dealer for eligibility. Not a guarantee of actual tax savings. Tax amounts and payment based ONLY on state sales tax rates in your state and excludes city, county, or municipality sales tax amounts. Savings on sales tax are dependent on state laws, owner status and state of registration.';
export const DEPRECIATION_DISCLAIMER =
  '**Average Depreciation are the opinions of Kelley Blue Book, and the actual depreciation may vary. Kelley Blue Book assumes no responsibility for errors or omissions.';

export const SCARCITY_RANGES = {
  HIGHLY_DESIRABLE: { MIN: 6.1, MAX: 10.0 },
  AVERAGE: { MIN: 4.1, MAX: 6.0 },
  LESS_DESIRABLE: { MIN: 0.1, MAX: 4.0 },
};
